var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"id":"img","crossorigin":"anonymous","src":_vm.Img,"alt":"","srcset":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }